import { useLocation } from "@reach/router";
import React, { ReactNode, useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";

import Header from "../components/Header";
import SideNav from "../components/Docs/SideNav";
import { DOCS_HEADER_HEIGHT } from "../components/Header/Header";
import { useWindowSize } from "../hooks";
import { M_BREAKPOINT } from "../styles";

const Container = styled.div<{ $navOpen: boolean }>`
  overflow-x: hidden;
  height: 100vh;
  padding-bottom: 5rem;
  background-color: var(--primary);

  @media (max-width: ${M_BREAKPOINT}px) {
    overflow-y: ${({ $navOpen }) => ($navOpen ? "hidden" : "auto")};
  }
`;

const ContentContainer = styled.section`
  margin-top: calc(var(--m) + ${DOCS_HEADER_HEIGHT});
  display: flex;
  justify-content: space-between;
  position: relative;
`;

interface DocsLayoutProps {
  children: ReactNode;
  path: string;
}

const DocsLayout = ({ children, path }: DocsLayoutProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const { width } = useWindowSize();

  const { hash } = useLocation();

  useEffect(() => {
    if (width > M_BREAKPOINT) {
      setSideNavOpen(false);
    }
  }, [width]);

  useEffect(() => {
    if (containerRef.current && hash.length === 0) {
      containerRef.current.scrollTo(0, 0);
    }

    setSideNavOpen(false);
  }, [path]);

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === "Escape") setSideNavOpen(false);
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return (
    <Container ref={containerRef} $navOpen={sideNavOpen}>
      <Header
        open={sideNavOpen}
        setOpen={setSideNavOpen}
      />
      <ContentContainer>
        <SideNav open={sideNavOpen} />
        {children}
        <div />
      </ContentContainer>
    </Container>
  );
};

export default DocsLayout;
